<template>
  <div>
    <v-app-bar app clipped-rigth color="primary" dark >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        <v-icon v-if="drawer">mdi-chevron-left</v-icon>
        <v-icon v-else>mdi-chevron-right</v-icon>
      </v-app-bar-nav-icon>
      
        <v-img src="../assets/logo2.png" alt="" width="1%" height="100%"></v-img>
      <v-toolbar-title>{{ user.nombre }}</v-toolbar-title>
        <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click.stop="drawerRight = !drawerRight"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer v-model="drawerRight" app right>
      <v-list dense>
        <v-list-item class="d-flex justify-center">
          <v-avatar  size="100">
            <img :src="user.emp.imagen_usuario" alt="Avatar">
          </v-avatar>
        </v-list-item>
        <br>
        <v-list-item @click="dialog = true">
          <v-list-item-action>
            <v-icon>mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Mi Cuenta</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="change()">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Modo Nocturno</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <v-list-item @click="imgLateral = !imgLateral">
          <v-list-item-action>
            <v-icon>mdi-newspaper</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Imagen Lateral</v-list-item-title>
          </v-list-item-content>          
        </v-list-item>
        <div v-if="imgLateral">
        <v-list-item v-for="(img, index) in imagenLateral" :key="index" @click="imagenbar(img.imagen)">
              <v-list-item-action>
                <v-icon>mdi-fullscreen</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ img.title }}</v-list-item-title>
              </v-list-item-content>
        </v-list-item>
        </div>

        <v-list-item @click="salir()">
          <v-list-item-action>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>    
      </v-list>
    </v-navigation-drawer>


    <v-navigation-drawer v-model="drawer" app left floating 
    :src="barImage">
      <v-list dense>
        
        <v-list-item class="d-flex justify-center">
          <v-avatar  size="100">
            <img src="../assets/logo.png" alt="Asesoratech">
          </v-avatar>
        </v-list-item>
        <!-- <v-list-item  v-if="user.nivel == 'usr'">
              <v-row dense>
                <v-col cols="12">
                  <v-card elevation="10" loading>
                    <v-card-subtitle>Tareas Pendientes</v-card-subtitle>
                      <v-card-text>
                        <p class="display-3" style="text-align: center !important;">1</p>
                      </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
        </v-list-item> -->

        <v-list-item router-link to="/dash"  v-if="user.nivel == 'usr'">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router-link to="/instituciones" v-if="user.nivel == 'sys'">
          <v-list-item-action>
            <v-icon>mdi-city</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Instituciones</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router-link to="/usuarios" v-if="user.nivel == 'adm'">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Usuarios</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item router-link to="/sysusr" v-if="user.nivel == 'sys'">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Usuarios Plataforma</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router-link to="/evaluaciones" v-if="user.nivel == 'adm' | user.nivel == 'usr'">
          <v-list-item-action>
            <v-icon>mdi-settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Evaluaciones</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router-link to="/competencias" v-if="user.nivel == 'adm'">
          <v-list-item-action>
            <v-icon>mdi-code-equal</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Competencias</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router-link to="/objetivos" v-if="user.nivel == 'adm'">
          <v-list-item-action>
            <v-icon>mdi-elevation-rise</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Objetivos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item router-link to="/reportes" v-if="user.nivel == 'adm'">
          <v-list-item-action>
            <v-icon>mdi-file-document</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Reportes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>
      <v-container fluid>
        <v-row>
          <v-col>
            <router-view/>
          </v-col>
        </v-row>
      </v-container>
    <!--<v-navigation-drawer v-model="right" fixed right temporary ></v-navigation-drawer>-->

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Mi cuenta:</span>
        </v-card-title>
        <v-card-subtitle class="d-flex justify-center">
        
      <image-input v-model="avatar">
        <div slot="activator">  
          <v-avatar size="100" v-if="avatarTmp">
            <v-img :src="avatarTmp" alt="Avatar de Usuario"> </v-img>
          </v-avatar>
          <v-avatar size="100" v-else class="grey lighten-3 mb-3">
            <span>Agregar Foto</span>
          </v-avatar>
        </div>
      </image-input>
        </v-card-subtitle>        
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="user.emp.nombres" label="Nombres" required outlined></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field v-model="user.emp.apellidos" label="Apellidos" required outlined></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click="clave = true">Cambiar Clave</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="clave" max-width="600px" :persistent="user.autopass == 0 ? true : false">
      <v-card>
        <v-card-title>
          <span class="headline">Actualizar/Cambiar Contraseña:</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="claveAnt" label="Contraseña Actual" :type="viewPass ? 'text' : 'password'" outlined></v-text-field>
                
              </v-col>

              <v-col :cols="viewPass ? '12': '6'">
                <v-text-field v-model="claveNueva1" label="Nueva Contraseña" :type="viewPass ? 'text' : 'password'" outlined></v-text-field>
              </v-col>

              <v-col cols="6" v-if="!viewPass">
                <v-text-field v-model="claveNueva2" label="Repita la Nueva Contraseña" type="password" outlined></v-text-field>
              </v-col>

              <v-col cols="12">
                <password-meter :password="claveNueva1" @score="onScore"/>
              </v-col>
              <ul>
                <li v-if="passMay"><s>Debe contener al menos una Letra Mayuscula</s></li>
                <li v-else>Debe contener al menos una Letra Mayuscula</li>

                <li v-if="passMin"><s>Debe contener al menos una Letra Minuscula</s></li>
                <li v-else>Debe contener al menos una Letra Minuscula</li>

                <li v-if="passNum"><s>Debe contener al menos un Numero</s></li>
                <li v-else>Debe contener al menos un Numero</li>

                <li v-if="passEsp"><s>Debe contener al menos un Caracter Especial (._#?!@$%^*-)</s></li>
                <li v-else>Debe contener al menos un Caracter Especial (._#?!@$%^*-)</li>

                <li v-if="passCar"><s>Debe contener al menos 8 Caracteres</s></li>
                <li v-else>Debe contener al menos 8 Caracteres</li>
              </ul>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
            <v-icon v-if="!viewPass" @click="viewPass = !viewPass">
              mdi-eye-off
            </v-icon>
            <v-icon v-else @click="viewPass = !viewPass">
              mdi-eye
            </v-icon>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text v-if="user.autopass != 0" @click="clave = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="cambiarClave" v-if="passOk && claveAnt.length > 0 && (viewPass || (claveNueva1 == claveNueva2))">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import api from '../conf/ruta-base';
import axios from 'axios';
import router from '../router';
import UserProfile from '../data';
import store from "../store";
import ImageInput from '../components/ImageInput';
import passwordMeter from "vue-simple-password-meter";
import swal from 'sweetalert';
  export default {
    name:'Home',
    components:{ImageInput,passwordMeter},
    props: {
      source: String,
    },
    data: () => ({
      user: UserProfile.getUserData(),
      avatar: null, drawer: true, drawerRight: false, right: false, left: false, barImage: '', imgLateral:false, score: 0, passReq: false,
      dialog: false, chosenFile: null, avatarTmp: null, clave: null, viewPass: false, claveAnt: '', claveNueva1: '', claveNueva2: '',
      imagenLateral: [
        { title: 'Sin Imagen', imagen: ''},
        { title: 'Actualidad', imagen: 'sid3'},
        { title: 'Nieve', imagen: 'sid1'},
        { title: 'Lago', imagen: 'sid2'},
        { title: 'Cordillera', imagen: 'sid4'},
      ], passMay: false, passMin: false, passLen: false, passNum: false, passEsp: false, passCar: false, passOk: false,
    }),
    created () {
      if(sessionStorage.token == undefined | sessionStorage.token == null){
        router.push('login')
      }
      if(this.user.autopass == 0){
        this.clave = true
      }
      if(localStorage.getItem('temaDark')=='true'){
        this.$vuetify.theme.dark = true
      }else{
        this.$vuetify.theme.dark = false
      }
      if(localStorage.getItem('barImage')){
        this.barImage = localStorage.getItem('barImage')
      }
    },
    mounted() {
      this.avatarTmp = this.user.emp.imagen_usuario
    },
    watch: {
      avatar(){
        this.avatarTmp = this.avatar.imageURL
        this.chosenFile = this.avatar.imageFile
      },
      claveNueva1(valor){
        let bandera = 0
        if(/(?=.*?[A-Z])/.test(valor)){
          bandera++
          this.passMay = true
        }else{
          this.passMay = false          
        }
        if(/(?=.*?[a-z])/.test(valor)){
          bandera++
          this.passMin = true
        }else{
          this.passMin = false          
        }
        if(/(?=.*?[0-9])/.test(valor)){
          bandera++
          this.passNum = true
        }else{
          this.passNum = false          
        }
        if(/(?=.*?[#?!._@$%^&*-])/.test(valor)){
          bandera++
          this.passEsp = true
        }else{
          this.passEsp = false          
        }
        if(valor.length >= 8){
          bandera++
          this.passCar = true
        }else{
          this.passCar = false          
        }                        
        if(bandera > 4){
          this.passOk = true
        }else{
          this.passOk = false
        }
      },
    },
    methods: {
      change() {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark
        localStorage.setItem('temaDark', this.$vuetify.theme.dark)
      },
      imagenbar(img){
        if(img==''){
          this.barImage = ''
          localStorage.setItem('barImage', '')
        }else{
          this.barImage = 'img/'+img+'.jpg'
          localStorage.setItem('barImage', 'img/'+img+'.jpg')
        }
        this.imgLateral = false
      },
      salir(){
        sessionStorage.clear();
        router.push('/');
      },
      save(){
        let img = new FormData()
        let opt = {
          headers: {
            'Accept': 'application/json','Content-Type': 'multipart/form-data',
          }
        }
        if(this.chosenFile !== null)
          img.append('imagen',this.chosenFile,this.chosenFile.name)
        img.append('id',this.user.emp.id)
        img.append('nombres',this.user.emp.nombres)
        img.append('apellidos',this.user.emp.apellidos)
        img.append('api',api.api)
        axios
          .put(api.api + 'empleado/micta', img, opt)
          .then(r => {
            this.dialog = false
            this.chosenFile = null
            this.toast(r.data.c, r.data.mensaje);
            let usrdata={
                  nivel: r.data.level,
                  nombre: r.data.nombres + ' ' + r.data.apellidos,
                  emp: {
                    apellidos: r.data.apellidos,
                    id: r.data.id,
                    idsupervisor: r.data.idsupervisor,
                    iduser: r.data.id,
                    imagen_usuario: r.data.imagen_usuario,
                    nombres: r.data.nombres,
                  }
                }
            UserProfile.setUserData(usrdata);
            this.user = usrdata
          })
          .catch(error => {
            console.log(error);
          });
      },
      
      cambiarClave(){
        let params={
          clave: this.claveAnt,
          clave_nueva: this.claveNueva1,
        }
        
        if(this.score <= 1){
          swal('',`La nueva clave es muy debil, favor ingrese una mejor clave`,'error')
          return null
        }

        if(!this.viewPass && this.claveNueva1 != this.claveNueva2){
          swal('',`La nueva clave no coincide, favor verifiquelas`,'error')
          return null
        }
        axios
            .put(api.api + 'user/changepass', params)
            .then(res => {
              this.toast(res.data.c, res.data.mensaje);
              if(res.data.c=='success'){
                this.claveAnt = ''
                this.claveNueva1 = ''
                this.claveNueva2 = ''
                this.clave = false
                swal('',`Por seguridad su session se cerrara y debera ingresar nuevamente`,'warning')
                .then(ok => {
                  if(ok)
                    this.salir()
                })
              setTimeout(this.salir,3000)
              }
            })
            .catch(error => {
              console.log(error);
            });
      },

      onScore({ score, strength }) {
        this.score = score;
      },

      saludar(sal){
        console.log(sal)
      },
      
      toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
      },
    },
  }
</script>
